module.exports = __webpack_public_path__ + "img/hot_air_balloon_w.2d13424c.svg";